export default "__VITE_ASSET__dac50c00__"